import { useEffect } from 'react';
import '../assets/styleZoom.css';
import '../assets/all.css';

import $ from 'jquery';

const WebChatZoomCrm = (props) => {
  const idDom = props.elementId;
  const socialGatewayUrl = props.socialGatewayUrl;
  const backgroundColor = props.backgroundColor;
  const color = props.color;
  useEffect(() => {
    // ADD CONTAINER BUBBLE CHATS
    const bubble = document.createElement('div');
    bubble.classList.add('bubblesChat');
    bubble.innerHTML =
      '<div id="zoom_messenger_plugin_iframe_minimized_flotante" class="zoom_messenger_plugin_iframe_minimized disactive spinBorders" style="background-color:' +
      backgroundColor +
      '; color:' +
      color +
      ';"><div id="zoom_messenger_plugin_iframe_minimized_encabezado_flotante"><p><i id="zoom_messenger_plugin_iframe_btnExpand" class="fas fa-expand"></i><i id="zoom_messenger_plugin_iframe_btnHome" class="fas fa-home"></i>Atención en línea<i id="zoom_messenger_plugin_iframe_btnClose" class="fas fa-chevron-down"></i></p></div><iframe id="zoom_messenger_plugin_iframe" class="zoom_messenger_plugin_iframe disactive" src="' +
      socialGatewayUrl +
      '" scrolling="no" style="color:{{ colorI }}"></iframe></div>';

    const tryAppend = () => {
      const el = document.getElementById(idDom);
      if (el) {
        el.append(bubble);
        setupListeners();
      } else {
        requestAnimationFrame(tryAppend);
      }
    };

    tryAppend();
    function setupListeners() {
      var expandIframe = false;
      var headerIndex;
      var headerDisplay;
      window.onload = function () {
        // console.log("Arranco");
        //Personalización de la presentación cuando existe un error en el formulario.

        var resizeHandle = document.getElementsByClassName(
          'zoom_messenger_plugin_iframe_minimized'
        );

        resizeHandle = resizeHandle[0];

        var expandBtn = document.getElementById('zoom_messenger_plugin_iframe_btnExpand');
        if (expandBtn) {
          expandBtn.addEventListener('mousedown', initialiseResize, false);
        }
        var w;
        var h;

        function initialiseResize() {
          console.log('initialize');

          window.addEventListener('mousemove', startResizing, false);
          window.addEventListener('mouseup', stopResizing, false);
          window.event.stopPropagation();
        }

        function startResizing(e) {
          w = resizeHandle.offsetLeft + parseInt(resizeHandle.style.width, 10);
          h = resizeHandle.offsetTop + parseInt(resizeHandle.style.height, 10);
          resizeHandle.style.transition = 'none';
          var width = w - e.clientX;
          var height = h - e.clientY;
          resizeHandle.style.width = width + 'px';
          resizeHandle.style.height = height + 'px';
        }

        function stopResizing() {
          resizeHandle.style.transition = '1s';
          window.removeEventListener('mousemove', startResizing, false);
          window.removeEventListener('mouseup', stopResizing, false);
        }
      };

      $(function () {
        $('#zoom_messenger_plugin_iframe_btnHome').on('click', function () {
          window.location.reload();
        });

        $('#zoom_messenger_plugin_iframe_btnExpand').on('click', function () {
          console.log(expandIframe);
          if (expandIframe == false) {
            expandIframe = true;
            $('.zoom_messenger_plugin_iframe_minimized')
              .css({ 'border-radius': '5px 10px 0px 20px' })
              .animate({ height: '70%', width: '93%' }, 100);
          } else {
            expandIframe = false;
            $('.zoom_messenger_plugin_iframe_minimized')
              .css({ 'border-radius': '5px 10px 0px 20px' })
              .animate({ height: '457px', width: '300px' }, 100);
          }
        });

        $('#zoom_messenger_plugin_iframe_btnClose').on('click', function (event) {
          event.stopPropagation();
          let widthScreen = window.screen.width;
          if ($('#zoom_messenger_plugin_iframe_minimized').hasClass('active')) {
            if (widthScreen <= 550) {
              $('header').css({ 'z-index': headerIndex });
              $('header').css({ visibility: headerDisplay });
              $('body').css({ overflow: 'initial' });
            }
            $('#zoom_messenger_plugin_iframe_btnClose').css({
              display: 'none',
            });
            $('#zoom_messenger_plugin_iframe_btnExpand').css({
              display: 'none',
            });
            $('#zoom_messenger_plugin_iframe_minimized')
              .removeClass('active')
              .addClass('disactive');

            $('#zoom_messenger_plugin_iframe_minimized')
              .css({ 'border-radius': '5px 10px 0px 50px' })
              .animate({ height: '50px', width: '300px' }, 100, function () {
                setTimeout(() => {
                  $('#zoom_messenger_plugin_iframe_minimized_encabezado img').css({
                    display: 'initial',
                  });
                  $('#zoom_messenger_plugin_iframe_minimized_encabezado p').css({
                    float: 'right',
                    'text-align': 'inherit',
                  });
                  $('iframe.zoom_messenger_plugin_iframe').css({
                    display: 'none',
                  });
                }, 700);
              });
          }

          if ($('#zoom_messenger_plugin_iframe_minimized_flotante').hasClass('active')) {
            if (widthScreen <= 550) {
              $('header').css({ 'z-index': headerIndex });
              $('header').css({ visibility: headerDisplay });
              $('body').css({ overflow: 'initial' });
            }
            $('#zoom_messenger_plugin_iframe_btnClose').css({
              display: 'none',
            });
            $('#zoom_messenger_plugin_iframe_btnExpand').css({
              display: 'none',
            });
            $('#zoom_messenger_plugin_iframe_minimized_flotante')
              .removeClass('active')
              .addClass('disactive spinBorders');

            $('#zoom_messenger_plugin_iframe_minimized_flotante')
              .css({ 'border-radius': '50px 50px 0px 50px' })
              .animate({ height: '80px', width: '80px' }, 100, function () {
                setTimeout(() => {
                  $('#zoom_messenger_plugin_iframe_minimized_encabezado_flotante img').css({
                    display: 'initial',
                  });
                  $('#zoom_messenger_plugin_iframe_minimized_encabezado_flotante p').css({
                    float: 'right',
                    'text-align': 'inherit',
                  });
                  $('iframe.zoom_messenger_plugin_iframe').css({
                    display: 'none',
                  });
                }, 700);
              });
            $('#zoom_messenger_plugin_iframe_minimized_encabezado_flotante p').animate({
              'font-size': '15px',
              'margin-bottom': '0',
            });
          }
        });

        $('#zoom_messenger_plugin_iframe_minimized').on('click', function () {
          console.log('click');
          let widthScreen = window.screen.width;
          let heightScreen = '100%';
          headerIndex = $('header').css('z-index');
          headerDisplay = $('header').css('visibility');
          if ($(this).hasClass('disactive')) {
            $(this).removeClass('disactive').addClass('active');
            $('#zoom_messenger_plugin_iframe_minimized_encabezado img').css({
              display: 'none',
            });
            $('#zoom_messenger_plugin_iframe_minimized_encabezado p').css({
              float: 'inherit',
              'text-align': 'center',
            });
            $('iframe.zoom_messenger_plugin_iframe').css({
              display: 'initial',
            });
            if (widthScreen <= 550) {
              $('header').css({
                cssText: 'z-index: -1, visibility: hidden !important',
              });
              $('body').css({ overflow: 'hidden' });
              $('#zoom_messenger_plugin_iframe_minimized')
                .css({ 'border-radius': '0' })
                .animate({ height: heightScreen, width: '100%' }, 100);
              // $("#zoom_messenger_plugin_iframe_btnHome").css({"display":"inline-block"});
              $('#zoom_messenger_plugin_iframe_btnClose')
                .removeClass('fa-chevron-down')
                .addClass('fa-home zoom_messenger_plugin_iframe_leftIcon');
              $('#zoom_messenger_plugin_iframe_btnClose').css({
                display: 'inline-block',
              });
            } else {
              $('#zoom_messenger_plugin_iframe_btnClose').css({
                display: 'inline-block',
              });
              $('#zoom_messenger_plugin_iframe_btnExpand').css({
                display: 'inline-block',
              });
              $('#zoom_messenger_plugin_iframe_minimized')
                .css({ 'border-radius': '5px 10px 0px 20px' })
                .animate({ height: '457px' }, 100);
            }
          }
        });

        $('#zoom_messenger_plugin_iframe_minimized_flotante.disactive').on(
          'click',
          function (event) {
            console.log(event);
            let widthScreen = window.screen.width;
            let heightScreen = '100%';
            headerIndex = $('header').css('z-index');
            headerDisplay = $('header').css('visibility');
            if ($(this).hasClass('disactive')) {
              $(this).removeClass('disactive spinBorders').addClass('active');
              $('#zoom_messenger_plugin_iframe_minimized_encabezado_flotante img').css({
                display: 'none',
              });
              $('#zoom_messenger_plugin_iframe_minimized_encabezado_flotante p').css({
                float: 'inherit',
                'text-align': 'center',
              });
              // $("iframe.zoom_messenger_plugin_iframe").css({"display":"initial"});
              $('iframe.zoom_messenger_plugin_iframe').css({
                display: 'block',
              });
              if (widthScreen <= 550) {
                $('header').css({
                  cssText: 'visibility: hidden !important; z-index: -1',
                });
                $('body').css({ overflow: 'hidden' });
                $('#zoom_messenger_plugin_iframe_minimized_flotante')
                  .css({ 'border-radius': '0' })
                  .animate({ height: heightScreen, width: '100%' }, 100);
                // $("#zoom_messenger_plugin_iframe_btnHome").css({"display":"inline-block"});
                $('#zoom_messenger_plugin_iframe_btnClose')
                  .removeClass('fa-chevron-down')
                  .addClass('fa-home zoom_messenger_plugin_iframe_leftIcon');
                $('#zoom_messenger_plugin_iframe_btnClose').css({
                  display: 'inline-block',
                });
              } else {
                $('#zoom_messenger_plugin_iframe_btnExpand').css({
                  display: 'inline-block',
                });
                $('#zoom_messenger_plugin_iframe_minimized_flotante')
                  .css({ 'border-radius': '5px 10px 0px 20px' })
                  .animate({ height: '457px', width: '300px' }, 100);
                $('#zoom_messenger_plugin_iframe_btnClose').css({
                  display: 'inline-block',
                });
              }

              $('#zoom_messenger_plugin_iframe_minimized_encabezado_flotante p').animate(
                { 'font-size': '22px', 'margin-bottom': '4px' },
                1000
              );
            }
          }
        );
      });
    }

    return () => {
      const el = document.getElementById(idDom);
      if (el && bubble.parentNode === el) {
        el.removeChild(bubble);
      }
    };
  }, [idDom, socialGatewayUrl, backgroundColor, color]);

  return <div style={{ display: 'none' }} />;
};

export default WebChatZoomCrm;
